@if (isLoaded()) {
  <div id="donnee_suivi_content">
    <!-- Section Routes d'équipements associées au tir -->
    @if (tabRoutes().length > 0) {
      <div class="routes-section mb-4">
        <h5 class="section-title">{{ 'DONNEE_SUIVI_OP.ASSOCIATED_EQUIPMENT_ROUTES' | translate }}</h5>
        <div class="table-box">
          <div class="table-border">
            <div style="max-height: 300px; overflow-y: auto;">
              <table>
                <thead style="background-color: #f8f9fa; position: sticky; top: 0; z-index: 1;">
                  <tr>
                    <th>{{ 'DONNEE_SUIVI_OP.MOBILE_EQUIPEMENT' | translate }}</th>
                    <th>{{ 'DONNEE_SUIVI_OP.START_DATE' | translate }}</th>
                    <th>{{ 'DONNEE_SUIVI_OP.END_DATE' | translate }}</th>
                    <th>{{ 'DONNEE_SUIVI_OP.DURATION' | translate }}</th>
                    <th width="50px"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (route of tabRoutes(); track route) {
                    <tr>
                      <td>{{ getEquipmentName(route.equipmentId) }}</td>
                      <td>{{ formatRouteDate(route.start) }} {{ formatRouteTime(route.start) }}</td>
                      <td>{{ formatRouteDate(route.end) }} {{ formatRouteTime(route.end) }}</td>
                      <td>
                        @if (route.start && route.end) {
                          {{ getDurationMinutes(route.start, route.end) }} min
                        }
                      </td>
                      @if (route.id) {
                        <td style="text-align: center;" title="{{ 'GLOBAL.SUPPRIMER' | translate }}"
                          (click)="showConfirmUnassignRoute(route.id)">
                          <i class="fa-solid fa-trash" style="color: tomato; cursor: pointer;"></i>
                        </td>
                      }
                      @if (!route.id) {
                        <td></td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }
    @if (tabShifts().length > 0) {
      <div id="content" class="noselect">
        <div class="table-box">
          <div class="table-border">
            <div style="max-height: 400px; overflow-y: auto;">
              <table>
                <thead style="background-color: #f8f9fa; position: sticky; top: 0; z-index: 1;">
                  <tr>
                    <th>{{ 'Date' }} <i class="fas"></i></th>
                    <th>{{ 'GLOBAL.OPERATORS' | translate }}</th>
                    <th>{{ 'DONNEE_SUIVI_OP.EQUIPE' | translate }}</th>
                    <th>{{ 'Shift' }}</th>
                    <th width="30%">{{ 'DONNEE_SUIVI_OP.MOBILE_EQUIPEMENT' | translate }}</th>
                    <th width="50px"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (x of tabShiftsSorted(); track trackByShiftId($index, x)) {
                    <tr>
                      <td (click)="ouvrirModale(x)">{{ x.date | date:'dd/MM/yyyy' }}</td>
                      <td (click)="ouvrirModale(x)">{{ x.operator?.nom }}</td>
                      <td (click)="ouvrirModale(x)">{{ x.equipe?.nom }}</td>
                      <td (click)="ouvrirModale(x)">{{ enumToString(x.time) | translate }}</td>
                      <td>
                        <ng-select name="equipements" id="equipements" [items]="tabEquipments()" [(ngModel)]="x.equipements"
                          [multiple]="true" bindLabel="displayName" [clearable]="false" [searchable]="false">
                        </ng-select>
                      </td>
                      <td style="text-align: center;" title="{{ 'GLOBAL.SUPPRIMER' | translate }}"
                        (click)="showConfirmSuppr(x.shiftId)">
                        <i class="fa-solid fa-trash" style="color: tomato;"></i>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }
    <button class="btn btn-primary" (click)="ouvrirModale(null)" style="margin-right:10px;"><i class="fas fa-plus"
    style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}</button>
    @if (estProjet()) {
      <button type="button" class="btn btn-primary" (click)="exportDonneeSuivi()"
        [disabled]="tabDonneesSuivi().length == 0">
        <i class="fas fa-file-export" style="padding-right:5px"></i>{{'GLOBAL.EXPORTER' | translate}}
      </button>
    }
  </div>
}

<div bsModal #modalExport="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name"
  [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left not-selectable">{{'GLOBAL.EXPORT_DONNEES' | translate}}</h4>
      </div>
      <div class="modal-body">
        <div class="not-selectable" [ngClass]="aucuneDonnee() ? '' :'text-center'">{{aucuneDonnee() ?
        ('GLOBAL.AUCUNE_DONNEE_EXPORT' | translate) : ('GLOBAL.PREPARATION_EXPORT' | translate)}}</div>
        @if (aucuneDonnee()) {
          <div class="btn-toolbar justify-content-end">
            <button type="button" class="btn btn-secondary" (click)="modalExport.hide()">{{'GLOBAL.FERMER' |
            translate}}</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>


<div bsModal #modalConfirmSuppr="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name"
  [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="deleteShift()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()"
        style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmUnassignRoute="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name"
  [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{ 'Désassigner cette route du tir ?' }}</p>
        <button type="button" class="btn btn-primary" (click)="unassignRoute()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideConfirmUnassignRoute()"
        style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>